<ng-rail-emission
  *ngIf="(store$ | async) as store"
  [loadingCompanies]="store.loadingCompanies"
  [loading]="store.loading"
  [companies]="store.companies"
  [reports]="store.reports"
  (report)="dispatchEmissionReport($event)"
  (resetReport)="reset()"
  (auditDownload)="dispatchAuditDownload($event)"
></ng-rail-emission>
